import type { TableData } from '@app/types/table'
import type { ResponseDto } from '@app/api/dtos'
import type { ResultPhotoDto } from '@app/api/routes/monitoringTasks/dtos'
import type { CompetitorsPhotoControlDataSource } from '../types'

export const adaptCompetitorsPhotoControlDataSource = (
  resultsPhotoResponse: ResponseDto<ResultPhotoDto>
): TableData<CompetitorsPhotoControlDataSource> => {
  const { count, results: resultsPhoto } = resultsPhotoResponse

  const dataSource: CompetitorsPhotoControlDataSource[] = resultsPhoto.map(dto => ({
    // TODO: с бека не приходит поле taskId
    key: dto.taskId,
    productCode: dto.productCode,
    count: dto.count
  }))

  return { count, dataSource }
}
